import React, { useEffect, useState } from "react";
import { object, func } from "prop-types";
import { EndDateText } from "../EndDateText";
import LoadingIndicatorComponent from "../../../atoms/loading-indicator";
import { useDeviceType } from "../../../customHooks/useDeviceType";
import "./my-account.m.css";

const ManageSubscription = ({ member, getSubscriptionForUser, cancelSubscription, initAccessType }) => {
  const [subscriptions, setSubscriptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMobile = useDeviceType() !== "desktop";
  const bgImage = {
    backgroundImage: 'url("/images/banners/Subscription-bg.png")',
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: isMobile ? "90% top" : "20% 10%",
  };

  useEffect(() => {
    if (initAccessType && getSubscriptionForUser) {
      initAccessType(() => {
        getSubscriptionForUser()
          .then((res) => {
            setSubscriptions(res.subscriptions);
          })
          .catch((err) => console.error("Error occurred inside manage subscription --->", err));
      });
    }
  }, [member, initAccessType]);

  const cancelSubscriptionHandler = async (subscriptionId) => {
    setLoading(true);
    try {
      const subscriptionIndex = subscriptions.findIndex((subscription) => subscription.id === subscriptionId);
      await cancelSubscription(subscriptionId);
      const updatedSubscriptions = [
        ...subscriptions.slice(0, subscriptionIndex),
        ...subscriptions.slice(subscriptionIndex + 1),
      ];
      setSubscriptions(updatedSubscriptions);
    } catch (err) {
      console.error("Error from cancelSubscription is --->", err);
    } finally {
      setLoading(false);
    }
  };

  const getActiveSubscriptions = (subscriptions = []) => {
    const activeSubscriptions = subscriptions
      .filter((plan) => plan.subscription_type === "standard")
      .filter((plan) => plan.status === "active");

    if (activeSubscriptions.length === 0) {
      const handleSubscribeClick = () => {
        window.location.href = "/subscription";
      };
      return (
        <div styleName="subscription-section">
          <h3 styleName="subscription-title">Active Subscription(s)</h3>
          <div styleName="subscription-cancel-card">
            <span styleName="plan-name">You don&apos;t have any active subscriptions.</span>
            <button styleName="cancel-button" onClick={handleSubscribeClick} disabled={loading}>
              Subscribe Now
            </button>
          </div>
        </div>
      );
    }

    return (
      <div styleName="subscription-section">
        <h3 styleName="subscription-title">Active Subscription(s)</h3>
        {activeSubscriptions.map((subscription, id) => {
          return (
            <div styleName="subscription-card" key={id}>
              <div styleName="subscription-info">
                <div>
                  <span styleName="plan-name">{`${subscription.plan_name}`}</span>
                  <span styleName="date-info">{`Rs ${Number(subscription.payment_amount)} / ${
                    subscription.duration_unit === "years" ? "Year" : "Month"
                  }`}</span>
                </div>
                <button
                  styleName="cancel-button"
                  onClick={() => cancelSubscriptionHandler(subscription.id)}
                  disabled={loading}
                >
                  Cancel Subscription
                </button>
              </div>
              <div styleName="date-info">
                <EndDateText subscription={subscription} />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const getExpiredSubscriptions = (subscriptions = []) => {
    const expiredPlans = subscriptions.filter(
      (plan) =>
        plan.status === "expired" &&
        (plan.subscription_type === "standard" || plan.subscription_type === "group_access")
    );

    if (expiredPlans.length === 0) return null;

    return (
      <div styleName="subscription-section">
        <h3 styleName="subscription-title">{expiredPlans.length === 1 ? "EXPIRED PLAN" : "EXPIRED PLANS"}</h3>
        {expiredPlans.map((subscription, id) => {
          return (
            <div styleName="subscription-card" key={id}>
              <div styleName="subscription-info">
                <span styleName="plan-name">{`${subscription.plan_name}`}</span>
                <EndDateText subscription={subscription} />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  if (!member) {
    return <div styleName="not-logged-in">Please Login to manage your subscriptions</div>;
  }
  return (
    <div styleName="subscription-container">
      <div styleName="title-section">
        <h2 styleName="sub-title">Manage Subscription</h2>
        <p styleName="description">
          View your active and expired subscriptions, and effortlessly switch plans to suit your needs.
        </p>
      </div>
      {subscriptions === null ? (
        <div styleName="loading-section">
          <LoadingIndicatorComponent loading={true} />
          <p>We are finding your subscriptions, Please wait...</p>
        </div>
      ) : (
        <div styleName="subscription-content">
          {getActiveSubscriptions(subscriptions)}
          {getExpiredSubscriptions(subscriptions)}
        </div>
      )}
    </div>
  );
};

ManageSubscription.propTypes = {
  member: object,
  getSubscriptionForUser: func,
  cancelSubscription: func,
  initAccessType: func,
};

export default ManageSubscription;
